<template>
    <ValidationObserver ref="userInfo" v-slot="{ handleSubmit, invalid }">
        <b-form @submit.prevent="handleSubmit(updateUser)">  
            <b-card header-tag="header" footer-tag="footer" class="mt-8 mb-8">
                <template v-slot:header>
                    <p class="mb-0" style="font-size: 21px">Actualización de Usuario</p>
                </template>
                <b-card-text>
                    <b-alert show variant="danger" v-if="errores">
                        <ul >
                            <li v-for="(item, index) in errors" :key="index">{{ item[0] }}</li>
                        </ul>
                    </b-alert>
                    <b-row class="pb-4">
                        <b-col>
                            <p class="mb-0" style="font-size: 21px">Compañia: <b>{{ userInfo.company_name }}</b></p>
                        </b-col>
                    </b-row>
                    <b-row>        
                        <b-col cols="12" md="6">
                            <ValidationProvider name="Nombre"  rules="required|min:3" v-slot="{ errors, valid }">
                                <b-form-group 
                                    label="Nombre Usuario:"
                                    label-for="nombre">
                                    <b-form-input
                                        id="nombre"
                                        v-model="userInfo.nombre"
                                        type="text"
                                        autocomplete="off"
                                        required
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        placeholder="Ingrese el nombre"
                                        ></b-form-input>
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6">
                            <ValidationProvider name="Email"  rules="required|email" v-slot="{ errors, valid }">
                                <b-form-group 
                                    label="Email:"
                                    label-for="email">
                                    <b-form-input
                                        id="email"
                                        v-model="userInfo.email"
                                        type="text"
                                        autocomplete="off"
                                        required
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        placeholder="Ingrese el correo"
                                        ></b-form-input>
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                
                </b-card-text>
                <template v-slot:footer>
                    <b-button variant="danger" class="mr-2" @click.prevent="back">
                        Cancelar
                    </b-button>
                    <b-button variant="success" :disabled="invalid" type="submit">
                        Actualizar
                    </b-button>
                </template>
            </b-card>
        </b-form>
    </ValidationObserver>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
export default {
    data(){
        return{
            userInfo: {},
            errors: {},
            errores: false,
            status: '',
        }
    },
    created(){
        this.getInfoUser();
        
    },
    computed:{
        ...mapState('auth', ['user']),
    },
    methods:{
        ...mapMutations(['setLoading']),
        async getInfoUser(){
            this.setLoading(true)
            await this.$conectar.post('/admin/users/find-user',{
                id: this.$route.params.id
            })
            .then(response => {
                this.userInfo = response.data.data.usuario;

            })
            .catch(e =>{
                console.log(e);
            })
            this.setLoading(false)
        },
        back(){
            this.$router.go(-1);
        },
        async updateUser(){
            this.setLoading(true)

            await this.$conectar.post('/admin/users/update-user-info', this.userInfo)
            .then(response=>{
                if(response.data.error == true){
                    this.errores = true;
                    this.errors = response.data.errors;
                }else{
                    this.$root.$bvToast.toast('Se actualizo el usuario correctamente', {
                        title: "Respuesta del servidor",
                        variant: "success",
                        solid: true
                    })
                    this.$router.push({ name: 'usersListAdmin' });
                }
                })
            .catch(response =>{
                console.log(response);
                this.$bvToast.toast("Parece que hubo un error en el servidor", {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
            })
            this.setLoading(false)
        }
    }
}
</script>